import React, { ReactNode } from 'react';
import { AlertCircle } from 'lucide-react';
import { useEnvironment } from '@/contexts/EnvironmentContext';
import { useRBAC } from '@/lib/rbac';
import { useSessionStore } from '@/stores/session';

interface AdminRouteProps {
  children: ReactNode;
}

export function StrategyLibraryAdminGate({ children }: AdminRouteProps) {
  const { features } = useEnvironment();
  const rbac = useRBAC();
  const hasScope = useSessionStore((state) => state.hasScope('strategy:admin'));

  if (!features.strategyAdmin) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] text-center space-y-3">
        <AlertCircle className="h-10 w-10 text-amber-500" />
        <div>
          <p className="text-lg font-semibold text-[var(--text-heading)]">Feature disabled</p>
          <p className="text-[var(--text-secondary)]">
            Strategy admin tools are not enabled for this environment.
          </p>
        </div>
      </div>
    );
  }

  const allowed = rbac.can('strategy_admin') || hasScope;
  if (!allowed) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] text-center space-y-3">
        <AlertCircle className="h-10 w-10 text-rose-500" />
        <div>
          <p className="text-lg font-semibold text-[var(--text-heading)]">Access denied</p>
          <p className="text-[var(--text-secondary)]">
            You need the `strategy:admin` permission to access this area.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
